import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppInfoService } from 'core/app-info/app-info.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    removeHPFListeners?: () => void;
  }
}

@Component({
  selector: 'app-payment-chase',
  templateUrl: './payment-chase.component.html',
  styleUrls: ['./payment-chase.component.scss'],
  standalone: false
})
export class PaymentChaseComponent implements OnInit, OnDestroy {
  url = '';
  isMobile: boolean;
  isNSLocale: boolean;
  subscription: Subscription;
  error;
  appStrings: AppLocalization;
  allowAttribute = false;
  isReady = false;
  private readonly hpfParentScriptId = 'chase-hpf-parent-script';

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private appInfoService: AppInfoService,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit() {
    this.url = this.data.url;
    this.isMobile = this.deviceService.isMobile();
    this.isNSLocale = this.appInfoService.isNSLocaleSelected();
    this.error = '';
    this.appStrings = this.appInfoService.appStrings;
    this.initializePaymentFrame();
  }

  ngOnDestroy(): void {
    if (this.appInfoService.isNSLocaleSelected()) {
      if (window.removeHPFListeners) {
        window.removeHPFListeners();
      }
      const scriptRef = document.getElementById(this.hpfParentScriptId);
      if (scriptRef) {
        scriptRef.remove();
      }
    }
  }

  private async initializePaymentFrame() {
    try {
      const tasks = [this.checkNetwork()];
      if (this.appInfoService.isNSLocaleSelected()) {
        tasks.push(this.ensureHpfParentScript());
      }
      await Promise.all(tasks);
      this.isReady = true;
    } catch (error) {
      this.error = this.appStrings?.quoteDetails_PaymentError || 'Unable to load Chase payment frame.';
    }
  }

  private async checkNetwork() {
    const publicNetwork = await this.isPublicNetwork();
    this.allowAttribute = !publicNetwork;
  }

  private async isPublicNetwork(): Promise<boolean> {
    try {
      const response = await fetch(`${window.location.origin}/index.html`, { method: 'HEAD' });
      return response.headers.has('x-cdn');
    } catch {
      return true;
    }
  }

  private ensureHpfParentScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (document.getElementById(this.hpfParentScriptId)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.id = this.hpfParentScriptId;
      script.type = 'text/javascript';
      script.async = false;
      script.src = environment.hpfPMChaseUrlHPS3;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Unable to load hpfParent script.'));
      document.head.appendChild(script);
    });
  }

}
